module.exports = __webpack_public_path__ + "media/images/icons/expander_round_up-f042769262e63efc91ba5e6d8096d3a9.svg";